export const BIG_TUBE_VOLUME = 1800
export const SMALL_TUBE_VOLUME = 800
export const MIN_BASE_PERCENT = 30
export const MIN_BASE_VOLUME = 200
export const MIN_SMALL_TUBE_INGREDIENT_VOLUME = SMALL_TUBE_VOLUME * 0.85
export const MIN_BISCUIT_ITEMS = 7
export const MIN_BAR_ITEMS = 8
export const MIN_BAG_ITEMS = 10
